
import ScreenFooterText from '@/modules/authentication/components/FooterText';
import SignUpRightPanelCarousel from '@/modules/authentication/sign-up/components/RightPanelCarousel';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Container from './container/Container';
import Spacing from './container/Spacing';
import Header from './header/Header';
import './layout.styles.css';
import LoginRightPanelCarousel from './login/RightPanel';
import { XpressForBusinessLogo } from './logos/Logo';
import Sidebar from './sidebar/Sidebar';
import routes from '@/constants/routes';

type Props = {
	children: React.ReactNode;
	includeSidebar?: boolean;
	includeHeader?: boolean;
};

export const Layout = ({
	children,
	includeSidebar = true,
	includeHeader = true,
}: Props) => {

	return (
		<div className="layout relative min-h-screen">
			{includeSidebar && <Sidebar />}
			<div className="full-width-column relative">
				{includeHeader && <Header />}

				<div className="relative flex h-full">
					<div className="content-inner relative w-full">
						{children}
					</div>
				</div>
			</div>

		</div>
	);
};

export const LayoutWithCarousel = ({ children }: Props) => {
	const location = useLocation();
	const path = location.pathname;

	const [isSignUpPage, setIsSignUpPage] = useState(false);

	useEffect(() => {
		if (path === routes['/sign-up']) {
			setIsSignUpPage(true);
		}
	}, [path]);

	{/* TODO[Phase2]: these page are bigger than screen height causing scrollbar to appear that is present on other sign up pages */ }
	return (
		<Container className="authentication-parent-container">
			<Container className="flex-container">
				<Container className="form-parent-container">
					<Container className="form-container">
						<XpressForBusinessLogo className="h-16 mb-6" />
						{children}
					</Container>
					<ScreenFooterText className="flex content-end items-end align-middle h-auto" />
				</Container>

				<Container className="py-4 hidden xl:block">
					{isSignUpPage ? <SignUpRightPanelCarousel /> : <LoginRightPanelCarousel />}
				</Container>
			</Container>
		</Container>
	);
};
